import styled from 'styled-components'
import { forwardRef, FC } from 'react'

interface ImagesProps {
  src: string,
  alt: string,
  totalCount: number,
  currentCount: number,
  ref: Object,
  open: Function,
  fillBg?: boolean
  fillContainer?: boolean
}

const Images: FC<ImagesProps> = ({ src, alt, totalCount, currentCount, open, fillBg, fillContainer }, ref) => (
  <ImageWrapper onClick={open} className={`position-relative mb-9 text-center ${fillBg ? 'fill-bg' : ''}`}>
    <Img
      ref={ref}
      src={src}
      alt={alt}
      $fillContainer={fillContainer}
      className='border-radius-standard'
    />
    {currentCount && totalCount && (
      <div className='text medium color-black left-0 p-4 bottom-0 position-absolute bg-white text-center'>
        <b>{currentCount}</b> / {totalCount}
      </div>
    )}
  </ImageWrapper>
  )

const ImageWrapper = styled.div<any>`
  &.fill-bg {
    background-color: var(--bs-mch-gray-200);
  }
`
const Img = styled.img<any>`
  cursor: zoom-in;
  ${({ $fillContainer }) => $fillContainer ? `
    width: 100%;
  ` :
  `
    max-height: 70vh;
    max-width: 100%;
  `}
`
//@ts-ignore
export default forwardRef(Images)
